import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const brands = [
  { name: 'Native Supply', logo: 'https://native.supply/cdn/shop/files/ns-logo-19-b-tj_200x.png' },
  { name: 'The Daily Grace', logo: 'https://thedailygraceco.com/cdn/shop/files/DailyGrace-Logos-update-WEB_1.png?'},
  { name: 'IV His Glory', logo: 'https://ivhisglory.com/cdn/shop/files/logofinal_240x.png' },
  { name: 'Elevated Faith', logo: 'https://cdn.shopify.com/s/files/1/0956/3508/files/ef-black.png' },
  { name: 'Kidan Clothing', logo: '/kmanual.png' },
  { name: 'Nhim Apparel', logo: 'https://nhimapparel.com/cdn/shop/files/NHIM_Logo_400x100_orange.png?v=1744829245&width=400' },
  { name: 'Forty-Six Ten Apparel', logo: 'https://fortysixten.net/cdn/shop/files/ftsapparelcowebsite_smallcopy_190x.png?v=1669780592' },
  { name: 'Hosanna Revival', logo: 'https://hosannarevival.com/cdn/shop/files/Logotype-Black-1000px_3e7b45f5-47fb-46ff-b858-1be0b827a07a.png?', }
  
];

export default function Brands() {

  const navigate = useNavigate();

  const handleBrandClick = (brandName) => {
        navigate(`/products?brand=${encodeURIComponent(brandName)}`);
  }

  return (
    <Box sx={{
      mt: 4,
      pt: 2,
      pb: 10,
      pl: 2,
      pr: 2,
      borderRadius: '6px 6px 0 0', // Only top borders curved
      background: '#1b3427',
      }}>
      {/* Header */}
      <Typography sx={{ 
        fontWeight: 'bold', fontSize: '2em', mb: 1.5, textAlign: 'center', color: 'white' }}>
        Featured Brands
      </Typography>

      {/* Brand Grid */}
      <Grid container spacing={2}>
        {brands.map((brand, index) => (
          <Grid item  size={{ xs: 6, sm: 4 }}  key={index}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: 2,
                height: 100, // Uniform height for all cards
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: '0 4px 8px rgba(253, 253, 253, 0.5)',
                },
              }}
              onClick={() => handleBrandClick(brand.name)}
            >
              <Box
                component="img"
                src={brand.logo}
                alt={brand.name}
                sx={{
                  filter: 'brightness(0) invert(1)',
                  maxWidth: '80%', // Ensures logos fit within the card
                  maxHeight: '60%', // Ensures logos maintain uniform size
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}